<!--Confirmation popup For Transactions-->
<p-dialog header="Delete Account" [(visible)]="displayTransactionAvailability" [modal]="true" [responsive]="true" [style]="{width: '60vw'}">
    <div class="header">
        <h5>Delete Warning</h5>
    </div>
    <div class="card"> <span style="font-weight: bold;">{{associatedTransactions}}</span></div>
    <br>
    <div> <span>Do you want to move it to another account ? </span></div>
    <liono-treeSelect class="border-bottom-input" [options]="accountTypes" appendTo="body" placeholder="Select Type" [(ngModel)]="selectedAccount" display="comma" [metaKeySelection]="false" selectionMode="single"></liono-treeSelect>

    <ng-template pTemplate="footer">
        <button pButton (click)="closeDialog()" label="Cancel" class="p-button-secondary"></button>
        <button pButton [disabled]="!selectedAccount" (click)="save()" label="Save"></button>
    </ng-template>
</p-dialog>